// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IPublicSuburbanV1ValidateAddressRequest,
  TPublicSuburbanV1ValidateAddressModel,
  IMappers,
  TPublicSuburbanV1ValidateAddressResponse,
  IPublicSuburbanV1ValidateAddressResponse,
  IPublicSuburbanV1ValidateAddressResponseError,
} from './types';

export const defaultConfig: TPublicSuburbanV1ValidateAddressModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/suburban/v1/validate-address/',
} as TPublicSuburbanV1ValidateAddressModel;

export function createPublicSuburbanV1ValidateAddressModel(
  parameters: IPublicSuburbanV1ValidateAddressRequest,
): TPublicSuburbanV1ValidateAddressModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IPublicSuburbanV1ValidateAddressOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IPublicSuburbanV1ValidateAddressRequest;
}

export async function fetchPublicSuburbanV1ValidateAddress<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicSuburbanV1ValidateAddressOptions<TResponse200, TResponse400>): Promise<
  TPublicSuburbanV1ValidateAddressResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createPublicSuburbanV1ValidateAddressModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IPublicSuburbanV1ValidateAddressResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IPublicSuburbanV1ValidateAddressResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TPublicSuburbanV1ValidateAddressResponse;
}
